import { z } from "zod";
import { tokenAliasOrValue } from "./base";

export const FontWeightValue = z.string();
export const FontWeightTokenData = tokenAliasOrValue(FontWeightValue);

export type FontWeightValue = z.infer<typeof FontWeightValue>;
export type FontWeightTokenData = z.infer<typeof FontWeightTokenData>;
